import { type Colors } from '@factorialco/deprecated-design-system'

import { nameFromHexCode } from 'modules/shift_management/lib/colors'

export const getColor = (color: string | null | undefined): Colors => {
  return color ? nameFromHexCode(color) : 'grey400'
}
